/*

 This is free and unencumbered software released into the public domain.

 Anyone is free to copy, modify, publish, use, compile, sell, or
 distribute this software, either in source code form or as a compiled
 binary, for any purpose, commercial or non-commercial, and by any
 means.

 In jurisdictions that recognize copyright laws, the author or authors
 of this software dedicate any and all copyright interest in the
 software to the public domain. We make this dedication for the benefit
 of the public at large and to the detriment of our heirs and
 successors. We intend this dedication to be an overt act of
 relinquishment in perpetuity of all present and future rights to this
 software under copyright law.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 IN NO EVENT SHALL THE AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR
 OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
 ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
 OTHER DEALINGS IN THE SOFTWARE.

 For more information, please refer to <http://unlicense.org/>

 */

import { useCallback, useRef, useState } from "react"
import { useObserver } from "lib/@components/virtual-window/useObserver"

export function useMeasurement() {
    const measure = useCallback(measureItem, [])
    const observer = useObserver(measure, [])
    const currentTarget = useRef(null)
    // a ref is just a function that is called
    // by React when an element is mounted
    // we use this to create an attach method
    // that immediately observes the size
    // of the reference
    const attach = useCallback(
        function attach(target) {
            if (!target) return
            currentTarget.current = target
            observer.observe(target)
        },
        [observer]
    )
    const [size, setSize] = useState({})

    // Return the size, the attach ref and the current
    // element attached to
    return [size, attach, currentTarget.current]

    function measureItem({ contentRect, target }) {
        if (contentRect.height > 0) {
            updateSize(target, contentRect)
        }
    }

    function updateSize(target, rect) {
        setSize({
            width: Math.ceil(rect.width),
            height: Math.ceil(rect.height),
            element: target,
        })
    }
}
